export const MS_IN_SECOND = 1000
